// extracted by mini-css-extract-plugin
export var boxContainer = "ManageYourBoxBanner_boxContainer__ohIUt";
export var boxName = "ManageYourBoxBanner_boxName__ROcae";
export var disclaimer = "ManageYourBoxBanner_disclaimer__WKmG9";
export var image = "ManageYourBoxBanner_image__2G8Bm";
export var imageContainer = "ManageYourBoxBanner_imageContainer__tcQXb";
export var nameAndLinkContainer = "ManageYourBoxBanner_nameAndLinkContainer__k1DGD";
export var prepaid = "ManageYourBoxBanner_prepaid__nysBp";
export var prepaidContainer = "ManageYourBoxBanner_prepaidContainer__ITl71";